import styles from "./settings.module.css";
import { useEffect, useMemo, useState } from "react";
import NotificationAlert from "./NotificationAlert";
import { cx } from "../../Util/classHelpers";
import UsersSettings from "../UsersAndRoles/UsersSettings";
import RoleSettings from "../UsersAndRoles/RoleSettings";
import { useFetchRolesQuery } from "../../Apis/rolesApi";

export const SETTINGS_COMPONENT = "SETTINGS_COMPONENT";

const tabs = [
  // {
  //   label: "General",
  //   component: () => <div>General</div>
  // },
  {
    label: "Users",
    component: UsersSettings
  },
  {
    label: "Roles",
    component: RoleSettings
  },
  // {
  //   label: "Billing",
  //   component: () => <div>Billing</div>
  // },
  // {
  //   label: "Location",
  //   component: () => <div>Location</div>
  // }
]

const SettingsWrapper = () => {
  const [notification, setNotification] = useState({text: "", variant: "success"});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { isLoading, data: roles } = useFetchRolesQuery();

  useEffect(() => {
    if (notification.text) {
      const timer = setTimeout(() => {
        setNotification({text: "", variant: "success"});
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const Component = useMemo(() => {
    return tabs[activeTabIndex]?.component;
  }, [activeTabIndex]);

  const setSuccessNotification = (text) => {
    setNotification({text, variant: "success"});
  }

  const setErrorNotification = (text) => {
    setNotification({text, variant: "error"});
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageContent}>
        <div className={styles.topBar}>
          <div className={styles.topBarHeading}>Settings</div>
          <div className={styles.tabContainer}>
            {tabs.map((tab, index) => (
              <div
                key={tab.label}
                className={cx(styles.tabItem, activeTabIndex === index && styles.tabItemActive)}
                onClick={() => setActiveTabIndex(index)}
              >
                <div className={styles.tabItemContent}>
                  <div className={cx(styles.tabLabel, activeTabIndex === index && styles.tabLabelActive)}>{tab.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {!isLoading && roles && (
          <Component setSuccessNotification={setSuccessNotification} setErrorNotification={setErrorNotification} />
        )}
      </div>

      <NotificationAlert text={notification.text} variant={notification.variant} />
    </div>
  );
};


export default SettingsWrapper
